/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../../../../api/index';
import * as core from '../../../../../core';
import * as serializers from '../../../../index';

export const CredentialUpdateLabelsRequest: core.serialization.Schema<
    serializers.CredentialUpdateLabelsRequest.Raw,
    Omit<Truvity.CredentialUpdateLabelsRequest, 'idempotencyKey' | 'ifMatch'>
> = core.serialization.object({
    labels: core.serialization.record(core.serialization.string(), core.serialization.string()),
});

export declare namespace CredentialUpdateLabelsRequest {
    export interface Raw {
        labels: Record<string, string>;
    }
}
